// extracted by mini-css-extract-plugin
module.exports = {"swiper":"Reviews_swiper__1mmGZ","slide":"Reviews_slide__2rHds","reviews":"Reviews_reviews__3j4P7","title":"Reviews_title__1SX1t","list":"Reviews_list__SKZih"};